import React from "react";
import "../OurStory.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { NavLink } from "react-router-dom";

import {
    FiHome,
    FiChevronRight,
} from "react-icons/fi";

const OurStory = () => {

    return (

        <>

            <Header />

            {/* =====================================================
                        HERO SECTION
            ===================================================== */}

            <section className="story-hero">

                <div className="story-overlay"></div>

                <div className="container">

                    <div className="story-hero-content">

                        <span className="story-tag">
                            Company Journey
                        </span>

                        <h1>
                            Our <span>Story</span>
                        </h1>

                        <p>
                            Every successful business begins with a vision.
                            Kishancart Digital (OPC) Private Limited was founded
                            with a mission to help startups, retailers,
                            enterprises, and agricultural businesses embrace
                            digital transformation through innovative,
                            scalable, and secure technology solutions.
                        </p>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        BREADCRUMB
            ===================================================== */}

            <section className="story-breadcrumb">

                <div className="container">

                    <div className="breadcrumb">

                        <NavLink to="/">
                            <FiHome />
                            Home
                        </NavLink>

                        <FiChevronRight />

                        <span>Company</span>

                        <FiChevronRight />

                        <span className="active">
                            Our Story
                        </span>

                    </div>

                </div>

            </section>

            {/* =====================================================
                    NEXT PART STARTS HERE
                    Our Journey + Why We Started
            ===================================================== */}

            {/* =====================================================
                        OUR JOURNEY
            ===================================================== */}

            <section className="our-journey">

                <div className="container">

                    <div className="story-grid">

                        {/* Left Content */}

                        <div className="story-content">

                            <span className="section-tag">
                                Our Journey
                            </span>

                            <h2>
                                Building Technology That
                                <span> Creates Opportunities</span>
                            </h2>

                            <p>
                                Kishancart Digital (OPC) Private Limited was
                                founded with a simple yet ambitious vision—to
                                help businesses embrace digital transformation
                                through innovative and reliable technology.
                                We recognized that many startups, retailers,
                                manufacturers, distributors, and agricultural
                                businesses needed affordable, scalable, and
                                future-ready software solutions.
                            </p>

                            <p>
                                From our first project, we focused on building
                                solutions that simplify business operations,
                                improve customer engagement, and accelerate
                                growth. Every website, mobile application,
                                marketplace, and enterprise solution we develop
                                is designed with performance, security, and
                                long-term scalability in mind.
                            </p>

                            <p>
                                Today, our journey continues as we expand our
                                expertise across e-commerce platforms,
                                multi-vendor marketplaces, retail management,
                                ERP systems, inventory solutions, mobile
                                applications, and custom software tailored to
                                modern business needs.
                            </p>

                        </div>

                        {/* Right Cards */}

                        <div className="journey-cards">

                            <div className="journey-card">

                                <h3>Innovation</h3>

                                <p>
                                    Continuously adopting modern technologies
                                    to deliver smart and future-ready business
                                    solutions.
                                </p>

                            </div>

                            <div className="journey-card">

                                <h3>Customer Focus</h3>

                                <p>
                                    Understanding every client's unique
                                    requirements and building solutions that
                                    support long-term success.
                                </p>

                            </div>

                            <div className="journey-card">

                                <h3>Quality Delivery</h3>

                                <p>
                                    Every project is developed with a strong
                                    focus on quality, reliability, security,
                                    and user experience.
                                </p>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        WHY WE STARTED
            ===================================================== */}

            <section className="why-started">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Why We Started
                        </span>

                        <h2>
                            Empowering Businesses Through
                            <span> Digital Innovation</span>
                        </h2>

                        <p>
                            Kishancart Digital was established with the belief
                            that technology should be practical, affordable,
                            and accessible to businesses of every size. Our
                            goal is to bridge the gap between traditional
                            business operations and modern digital e-commerce.
                        </p>

                    </div>

                    <div className="purpose-grid">

                        <div className="purpose-card">

                            <h3>🚀 Our Purpose</h3>

                            <p>
                                To create scalable digital solutions that help businesses
                                simplify operations, improve productivity, and grow confidently
                                in today's digital economy.
                            </p>

                        </div>

                        <div className="purpose-card">

                            <h3>💡 Our Inspiration</h3>

                            <p>
                                We recognized that many businesses struggled to adopt modern
                                technology due to complexity and high costs. This inspired us
                                to build practical, affordable, and user-friendly digital
                                solutions that deliver real business value.
                            </p>

                        </div>

                        <div className="purpose-card">

                            <h3>🌱 Our Growth Philosophy</h3>

                            <p>
                                We believe technology should grow alongside your business. Every
                                solution we build is designed to be scalable, adaptable, and
                                future-ready, enabling long-term success in an evolving digital
                                landscape.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                    NEXT PART STARTS HERE
                    Growth Timeline + Our Impact
            ===================================================== */}

            {/* =====================================================
                        GROWTH TIMELINE
            ===================================================== */}

            <section className="story-timeline">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Our Growth Journey
                        </span>

                        <h2>
                            Milestones That Shape
                            <span> Our Future</span>
                        </h2>

                        <p>
                            Every milestone reflects our commitment to innovation,
                            continuous improvement, and delivering digital solutions that
                            empower businesses to grow in an increasingly connected world.
                        </p>

                    </div>

                    <div className="timeline">

                        <div className="timeline-item">

                            <div className="timeline-year">
                                2026
                            </div>

                            <div className="timeline-content">

                                <h3>Company Founded</h3>

                                <p>
                                    Kishancart Digital (OPC) Private Limited was established
                                    to help businesses embrace digital transformation through
                                    innovative e-commerce platforms, enterprise software,
                                    and technology-driven solutions.
                                </p>

                            </div>

                        </div>

                        <div className="timeline-item">

                            <div className="timeline-year">
                                2026
                            </div>

                            <div className="timeline-content">

                                <h3>Service Portfolio Expansion</h3>

                                <p>
                                    We introduced a wide range of services including
                                    e-commerce development, ERP & CRM solutions, business
                                    websites, inventory management systems, and custom
                                    software development tailored to modern business needs.
                                </p>

                            </div>

                        </div>

                        <div className="timeline-item">

                            <div className="timeline-year">
                                Growing
                            </div>

                            <div className="timeline-content">

                                <h3>Industry-Focused Solutions</h3>

                                <p>
                                    We continue expanding our expertise by delivering
                                    industry-specific digital solutions for retail,
                                    agriculture, healthcare, education, logistics,
                                    manufacturing, grocery, and fashion businesses.
                                </p>

                            </div>

                        </div>

                        <div className="timeline-item">

                            <div className="timeline-year">
                                Future
                            </div>

                            <div className="timeline-content">

                                <h3>Innovation & Growth</h3>

                                <p>
                                    Our vision is to leverage AI, cloud computing,
                                    enterprise automation, and next-generation digital
                                    commerce technologies to help businesses stay ahead in
                                    a rapidly evolving digital landscape.
                                </p>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        OUR IMPACT
            ===================================================== */}

            <section className="story-impact">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Our Impact
                        </span>

                        <h2>
                            Building Success Through
                            <span> Technology</span>
                        </h2>

                        <p>
                            We are committed to helping businesses grow with
                            innovative digital platforms, reliable software,
                            and customer-focused technology solutions.
                        </p>

                    </div>

                    <div className="impact-grid">

                        <div className="impact-card">

                            <h3>100%</h3>

                            <h4>Client Focused</h4>

                            <p>
                                Every project is designed around business
                                goals, customer needs, and long-term value.
                            </p>

                        </div>

                        <div className="impact-card">

                            <h3>Secure</h3>

                            <h4>Technology Stack</h4>

                            <p>
                                Modern development practices with reliable,
                                secure, and scalable architectures.
                            </p>

                        </div>

                        <div className="impact-card">

                            <h3>Multi</h3>

                            <h4>Industry Expertise</h4>

                            <p>
                                Solutions for retail, agriculture,
                                manufacturing, healthcare, education,
                                logistics, and more.
                            </p>

                        </div>

                        <div className="impact-card">

                            <h3>24×7</h3>

                            <h4>Technical Support</h4>

                            <p>
                                Dedicated support, maintenance, and continuous
                                improvements to keep businesses running
                                smoothly.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                    NEXT PART STARTS HERE
                    Looking Ahead + CTA + Footer
            ===================================================== */}

            {/* =====================================================
                        LOOKING AHEAD
            ===================================================== */}

            <section className="looking-ahead">

                <div className="container">

                    <div className="looking-wrapper">

                        <span className="section-tag">
                            Looking Ahead
                        </span>

                        <h2>
                            Shaping the Future Through
                            <span> Innovation</span>
                        </h2>

                        <p>
                            At Kishancart Digital (OPC) Private Limited, our
                            journey has only just begun. As technology
                            continues to evolve, we remain committed to helping
                            businesses embrace digital transformation through
                            innovative, secure, and scalable software
                            solutions.
                        </p>

                        <p>
                            We aim to expand our expertise in e-commerce,
                            marketplace platforms, business automation,
                            enterprise software, mobile applications, cloud
                            technologies, and AI-driven solutions that empower
                            organizations to operate more efficiently and
                            compete confidently in a rapidly changing digital
                            world.
                        </p>

                        <p>
                            Our long-term vision is to become a trusted
                            technology partner for startups, retailers,
                            manufacturers, agricultural businesses, and
                            enterprises by delivering reliable solutions,
                            exceptional customer service, and continuous
                            innovation.
                        </p>

                        <div className="future-points">

                            <div className="future-item">
                                <span>✓</span>
                                <p>Expand innovative digital commerce solutions.</p>
                            </div>

                            <div className="future-item">
                                <span>✓</span>
                                <p>Support businesses with scalable software platforms.</p>
                            </div>

                            <div className="future-item">
                                <span>✓</span>
                                <p>Build AI-enabled and cloud-based business applications.</p>
                            </div>

                            <div className="future-item">
                                <span>✓</span>
                                <p>Strengthen long-term partnerships through technology and trust.</p>
                            </div>

                        </div>

                    </div>

                </div>

            </section>

            <Footer />

        </>

    );

};

export default OurStory;